import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1df65492"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-wrap footer-wrap" }

import { ref } from 'vue'
import { formatDate } from '@/utils/formatDate'
import { useRoute } from 'vue-router'

export default {
  __name: 'footer',
  setup(__props) {

const route = useRoute()


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["footer", _unref(route).path.includes('pcourse') ? 'pcourse' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(formatDate)(new Date(),'YYYY')) + " 年 ", 1)
  ], 2))
}
}

}